import {
  eolsBaseApi,
  withApiErrorLoggingOnly
} from '../../utilities/api.utilities';
import { CourseSectionDto, LtiCourseSectionDto } from './eols-course-crud.dtos';
import { addSearchParams } from '../../utilities/app.utilities';

export const fetchCourseSection = (courseId: string): Promise<CourseSectionDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get<CourseSectionDto>(`/courseSections/${courseId}`);
  });
};

export const fetchUserCourseSections = (userId: string, active = true, entitled?: boolean): Promise<CourseSectionDto[]> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get<CourseSectionDto[]>(addSearchParams('/courseSections', { entitled, userId, active }));
  });
};

export const fetchLaunchCourse = (courseSectionId: string): Promise<LtiCourseSectionDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get<LtiCourseSectionDto>(addSearchParams('/v3/launch/course', { courseSectionId }));
  });
};
